import React from 'react';
import { withGlobals } from '../hoc/withGlobals';

const Input = ({ context: { skin }, className, ...other }) => (
  <input className={`input ${className || ''}`} type="text" {...other} />
);

export default withGlobals(Input);
